<template>
    <div class="branch-card"
        :class="{ 'is-selected': selected, 'is-clickable': branch.region }"
        :tabindex="branch.region ? 0 : -1"
        :role="branch.region ? 'button' : null"
        :aria-pressed="branch.region ? String(selected) : null"
        @click="branch.region && $emit('select', branch.name)"
        @keydown.enter.space.prevent="branch.region && $emit('select', branch.name)">
        <label class="d-block yellow--text text--darken-3 font-weight-bold mb-2">{{ branch.name }}</label>
        <div class="branch-line">
            <v-icon small color="yellow darken-3">mdi-map-marker</v-icon>
            <span>{{ branch.address }}</span>
        </div>
        <div v-if="branch.mobile" class="branch-line">
            <v-icon small color="yellow darken-3">mdi-phone</v-icon>
            <a :href="'tel:' + branch.mobile.replace(/-/g, '')" @click.stop>{{ branch.mobile }}</a>
        </div>
        <a class="branch-map-link" :href="mapUrl" target="_blank" rel="noopener" @click.stop>
            <v-icon x-small color="yellow darken-3">mdi-open-in-new</v-icon> ดูแผนที่
        </a>
    </div>
</template>

<script>
export default {
    props: {
        // { name, address, mobile?, region }
        branch: { type: Object, required: true },
        selected: { type: Boolean, default: false }
    },
    computed: {
        mapUrl(){
            return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(this.branch.address || '');
        }
    }
};
</script>

<style scoped>
.branch-card {
    height: 100%;
    padding: 16px;
    text-align: left;
    border: 1px solid rgba(196, 156, 79, 0.35);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.03);
    transition: border-color 0.25s ease, background-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
}
.branch-card.is-clickable {
    cursor: pointer;
}
.branch-card.is-clickable:hover,
.branch-card.is-clickable:focus-visible {
    outline: none;
    border-color: rgba(196, 156, 79, 0.8);
    transform: translateY(-2px);
}
.branch-card.is-selected {
    border-color: #ffcf66;
    background: rgba(255, 207, 102, 0.1);
    box-shadow: 0 0 0 1px #ffcf66, 0 6px 24px rgba(255, 207, 102, 0.25);
    transform: translateY(-2px);
}
.branch-line {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 6px;
    color: #e0e0e0;
}
.branch-line .v-icon {
    margin-top: 3px;
}
.branch-line a {
    color: #e0e0e0;
}
/* พื้นที่กดสูงอย่างน้อย 36px ให้กดง่ายบนจอสัมผัส */
.branch-map-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-height: 36px;
    padding-right: 8px;
    color: #C49C4F !important;
    font-size: 0.875rem;
    text-decoration: none;
}
.branch-map-link:hover {
    text-decoration: underline;
}
</style>
